import firebase from "firebase";
import "firebase/firestore";

// Initialize Firebase
var config = {
  apiKey: "AIzaSyD1Yi5A8iCx8aToNJNjCjvR5oUkK6ox31Y",
  authDomain: "stacker-tracker.firebaseapp.com",
  databaseURL: "https://stacker-tracker.firebaseio.com",
  projectId: "stacker-tracker",
  storageBucket: "stacker-tracker.appspot.com",
  messagingSenderId: "1072107837373"
};
const firebaseApp = firebase.initializeApp(config);
firebaseApp.firestore().settings({ timestampsInSnapshots: true });

export default firebaseApp.firestore();



// WEBPACK FOOTER //
// ./src/firebase/init.js